import DiscountDetails from './discount-details.vue';

export default DiscountDetails;
